import _defineProperty from '@babel/runtime/helpers/defineProperty';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['card', 'header', 'headerAddon', 'editButton', 'empty', 'body', 'footer'];
var defaultPy = 2.5;
var defaultP = {
  base: 4,
  md: 6
};
var baseStyleBody = {
  textStyle: 'text',
  fontSize: 'md',
  py: defaultPy
};
var baseStyle = {
  card: {
    layerStyle: 'card',
    p: defaultP,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    transitionTimingFunction: 'ease-in'
  },
  header: {
    textStyle: 'heading',
    fontSize: '2xl',
    pt: 1,
    pb: defaultPy,
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px',
    borderBottomColor: 'gray.300'
  },
  editButton: {},
  headerAddon: {
    ml: 'auto',
    pl: 1,
    display: 'flex',
    alignItems: 'center'
  },
  body: _objectSpread({}, baseStyleBody),
  empty: _objectSpread(_objectSpread({}, baseStyleBody), {}, {
    color: 'gray.400',
    // @TODO: Remove this when bootstrap text-compatibility was removed.
    '& .chakra-text': {
      color: 'gray.400'
    }
  }),
  footer: {
    display: 'flex',
    '& > *:not(style) ~ *:not(style)': {
      ml: 2
    }
  }
};
function variantEdit() {
  return {
    card: {
      shadow: 'sm',
      _active: {
        shadow: 'md'
      }
    },
    footer: {
      justifyContent: 'flex-end',
      borderTop: '1px',
      borderTopColor: 'gray.300',
      pt: defaultPy
    }
  };
}
var variants = {
  edit: variantEdit
};
var defaultProps = {
  variant: 'default'
};
var Card = {
  parts: parts,
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: defaultProps
};
export { Card as default };